<template>
  <div>
    <h5 v-if="!consequences.length && readOnly">No hay consecuencias</h5>
    <form v-if="!readOnly" class="container" v-on:submit.prevent autocomplete="off">
      <div class="row">
        <div class="col-5">
          <vs-select
            autocomplete
            class="w-100"
            :label="'Tipo '"
            v-model="type"
            name="type"
            placeholder="Seleccione..."
          >
            <vs-select-item
              autocomplete="off"
              :key="item.id"
              :value="item"
              :text="item.nombre"
              v-for="item in consequencesTypes"
            />
          </vs-select>
        </div>
        <div class="col-5">
          <vs-select
            :disabled="!type"
            autocomplete
            class="w-100"
            label="Proceso"
            v-model="process"
            name="process"
            placeholder="Seleccione..."
          >
            <vs-select-item
              autocomplete
              :key="item.id"
              :value="item"
              :text="item.descripcion"
              v-for="item in filteredConsequences"
            />
          </vs-select>
        </div>
        <div class="col-2 mt-3">
          <vs-icon
            class="mt-5 w-100 cursor-pointer"
            icon="add_circle_outline"
            size="medium"
            v-tooltip="'Agregar consecuencia'"
            color="success"
            @click="addConsequence"
            data-cy="add-consequence"
          />
        </div>
      </div>
    </form>
    <div class="row mt-5">
      <div class="col-12">
        <table class="table text-center table-responsive" v-if="consequences.length">
          <thead>
          <tr>
            <th scope="col">Tipo</th>
            <th scope="col">Proceso</th>
            <th  v-if="!readOnly" scope="col">Acciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="consequence in consequences" :key="consequence.key"
              :name="'tr-'+consequence.key">
            <td>{{ consequence.estado }}</td>
            <td>{{ consequence.proceso }}</td>
            <td v-if="!readOnly">
              <div class="d-flex">
                <vs-icon
                  class="w-100 cursor-pointer"
                  icon="settings"
                  size="medium"
                  v-tooltip="'Configurar consecuencia'"
                  color=""
                  @click.prevent="configureConsequenceModal(consequence)"
                />
                <vs-icon
                  class="w-100 cursor-pointer"
                  icon="remove_circle_outline"
                  size="medium"
                  v-tooltip="'Eliminar consecuencia'"
                  color="danger"
                  @click="removeConsequence(consequence)"
                />
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      id='consecuencia'
      ref="consecuencia"
      size="lg"
      :title="modalTitle"
      hide-footer
      no-close-on-backdrop
      centered
    >
      <consequence
        ref="consecuencemodal"
        :consequence="consequence"
        :processconfig="processconfig"
        :reference="reference"
        :readonly="readOnly"
        @close="$bvModal.hide('consecuencia')"
        @configurate="configurateConsecuence"
      />
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import Consequence from './ConsequenceModal';

import consecuenceTypes from '@/febos/chile/approvals/mixins/ConsequenceTypes';
import AprovalMixin from '@/febos/chile/approvals/components/templates/AprovalMixin';
import Base64Mixin from '@/febos/global/_vue/mixins/Base64Mixin';
// requiere by config consequence

export default {
  name: 'Consequences',
  props: ['reference', 'original', 'readOnly'],
  mixins: [Base64Mixin, AprovalMixin],
  components: {
    Consequence
  },
  data() {
    return {
      type: '',
      process: '',
      extra: '',
      consequences: [],
      consequence: null,
      processconfig: null,
      consequencesTypes: consecuenceTypes,
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'consequenceOptions'
    ]),
    modalTitle() {
      console.log('PEPEPE', this.consequence);
      return this.consequence ? `${this.consequence.proceso} - ${this.consequence.estado}` : '';
    },
    filteredConsequences() {
      const prefilter = this.consequenceOptions
        .filter((option) => {
          let extra;
          try {
            extra = JSON.parse(option.extra);
          } catch (e) {
            // Si no es JSON, lo ignoramos
            return false;
          }
          return (
            extra.tipo === '*'
            || (typeof extra.tipo === 'string' && extra.tipo.split(',').includes(this.reference))
          );
        });
      return prefilter.filter((option) => (
        !this.type
        || !this.consequences.find((value) => value.key === `${this.type.id}&${option.opcionId}`)
      ));
    }
  },
  methods: {
    ...mapActions('Approvals', ['getConsequencesOptions']),
    notify(message) {
      this.$vs.notify({
        title: 'Oops!',
        text: message,
        color: 'danger',
        time: 10000,
        position: 'top-center'
      });
    },
    removeConsequence(item) {
      this.consequences = this.consequences
        .filter((consequence) => consequence.key !== item.key);
      this.$emit('consequences', this.consequences);
    },
    addConsequence() {
      const alreadySelected = this.consequences.find(
        (item) => item.aprobacionesGatilladorProcesoId === this.process.opcionId
          && item.aprobacionesGatilladorId === this.type.id
      );
      if (alreadySelected) {
        this.notify('Esta consecuencia ya esta seleccionada');
        return;
      }
      if (!Object.keys(this.process).length || !Object.keys(this.type).length) {
        this.notify('Debes elegir opciones para agregar');
        return;
      }
      const consequence = {
        key: `${this.type.id}&${this.process.opcionId}`,
        aprobacionesGatilladorId: this.type.id,
        aprobacionesGatilladorProcesoId: this.process.opcionId,
        estado: this.type.nombre,
        proceso: this.process.descripcion,
        configuracion: 'e30='
      };
      const configuration = this.consequenceOptions.find(
        (option) => option.opcionId === consequence.aprobacionesGatilladorProcesoId
      );
      const extra = JSON.parse(configuration.extra);
      const configurations = [];
      this.configureConsequence(
        consequence,
        extra.configuracion,
        (config) => {
          configurations.push(config);
        }
      );
      const newConfiguration = {};
      configurations.forEach((config) => {
        newConfiguration[config.id] = config.value;
        return config;
      });
      consequence.configuracion = this.encode(JSON.stringify(newConfiguration));
      this.consequences.push(consequence);
      this.$emit('consequences', this.consequences);
      this.process = '';
      this.type = '';
    },
    configureConsequenceModal(consequence) {
      const configuration = this.consequenceOptions.find(
        (option) => option.opcionId === consequence.aprobacionesGatilladorProcesoId
      );
      this.consequence = consequence;
      this.processconfig = configuration;
      this.$refs.consecuencia.show();
    },
    configurateConsecuence(newConfig) {
      this.consequence.configuracion = newConfig;
      this.$refs.consecuencia.hide();
      this.$emit('consequences', this.consequences);
    }
  },
  async mounted() {
  },
  async created() {
    await this.getConsequencesOptions();
    if (this.original) {
      this.consequences = this.original;
      this.consequences.forEach((item) => {
        const value = item;
        value.key = `${value.aprobacionesGatilladorId}&${value.aprobacionesGatilladorProcesoId}`;
      });
    };
  }
};
</script>
